import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { ISensitiveCommunities } from 'src/models/sensitive-communities.model';
import { useSensitiveCommunitiesContext } from 'src/contexts/sensitive-communities.context';
import { actionTypes } from 'src/ducks/sensitive-communities.duck';
import { getSensitiveCommunitiesStatus } from 'src/selectors/sensitive-communities.selector';
import style from '../sensitive-communities-list/sensitive-communities-list.module.scss';

type IProp = {
  data: ISensitiveCommunities;
};

const SensitiveCommunityDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useSensitiveCommunitiesContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getSensitiveCommunitiesStatus(
    state,
    actionTypes.SENSITIVE_COMMUNITIES_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.sensitiveCommunityId) {
      const response = await actions.itemDELETE(data.sensitiveCommunityId);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(
            Lang.MSG_SENSITIVE_COMMUNITY_DELETE_SUCCESS,
            data.sensitiveCommunity
          )
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_SENSITIVE_COMMUNITIES}
      content={
        <div className={style.content}>
          {Lang.formatString(Lang.MSG_CONFIRM_DELETE, data.sensitiveCommunity)}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default SensitiveCommunityDelete;
